// directives/html.js
export const html = {
    selector: '[data-html]',
    reactive: true,
    run(el, data, root) { 
        const key = el.getAttribute('data-html');
        el.innerHTML = data[key] || '';

        if (!root.__bindings) root.__bindings = {};
        if (!root.__bindings[key]) root.__bindings[key] = [];
        root.__bindings[key].push((val) => {
            el.innerHTML = val;
        });
    }
};